export default __webpack_public_path__ + "static/media/english-to-vietnamese-screenshot-06.d2d0126e.png";